import { InterLabAffectedSamples, InterLabCopy, InterLabTransfer } from 'Components/InterLab';
import { InterLabWorkOrderSection } from 'Components/InterLab/Share';
import { InterLabActionOption } from 'Components/InterLab/types';
import { PageSection } from 'Components/Layout';
import Page from 'Components/Pages/Core/Page';
import { hasValue } from 'Lib/Any';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

const InterLabPage: React.FC = () => {
  const params = useParams();

  const workOrderUUID = params.workOrderId?.toLowerCase();

  const workOrderId = useSelector((state) => state.interLab.workOrder?.workOrderId);

  const [actionOption, setActionOption] = useState<InterLabActionOption>('transfer');

  const handleSelectedOptionChange = (option: InterLabActionOption) => setActionOption(option);

  return (
    <Page heading="Inter-Laboratory Testing">
      <PageSection heading="Transfer Setup">
        <InterLabWorkOrderSection
          workOrderUUID={workOrderUUID}
          actionOption={actionOption}
          onActionOptionChange={handleSelectedOptionChange}
        />
        {actionOption === 'transfer' && <InterLabTransfer />}
        {actionOption === 'copy' && <InterLabCopy />}
      </PageSection>

      {hasValue(workOrderId) && <InterLabAffectedSamples actionOption={actionOption} />}
    </Page>
  );
};

export default InterLabPage;
